export const AR_TOOLTIP_KEY = '@ARButtonTooltipShown';
export const AR_INTRO_KEY = '@ARIntroShown';
export const INAPP_BROWSER_KEY = '@InAppBrowserNotificationShown';
export const AUTH_TOKEN_KEY = '@AppAuthToken';
export const AUTH_USER_KEY = '@AppAuthUser';
export const FEEDBACK_KEY = '@FeedbackAsked';
export const TLV_TOKEN = '@TLVToken';
export const DEVICE_ID_KEY = '@DeviceId';
